import CityPageTemplate from "../city-template/CityPageTemplate";
import { atlantaConfig } from "./data";

export default function AtlantaPage() {
  return <CityPageTemplate config={atlantaConfig} />;
}